import type { ManualPatientRecord, ManualPatientType } from '../types';

export const MANUAL_PATIENT_LABELS: Record<ManualPatientType, string> = {
  MI: 'Minor Injury',
  PRF: 'Patient Report Form',
  PAR: 'Paracetamol',
};

export const MANUAL_PATIENT_LIST_LABELS: Record<ManualPatientType, string> = {
  MI: 'Minor Injury (paper)',
  PRF: 'Patient Report Form (paper)',
  PAR: 'Paracetamol (paper)',
};

export function manualPatientFormBadge(type: ManualPatientType): string {
  return MANUAL_PATIENT_LABELS[type];
}

export interface PatientListRow {
  id: string;
  incidentId: string;
  eventId?: string;
  submittedAt: string;
  submittedByName: string;
  formTypeLabel: string;
  patientLabel: string;
  isPaper: boolean;
  notes?: string;
}

export function manualRecordsToListRows(
  incidentId: string,
  eventId: string | undefined,
  records: ManualPatientRecord[] | undefined,
): PatientListRow[] {
  return (records || []).map((record) => ({
    id: record.id,
    incidentId,
    eventId,
    submittedAt: record.recordedAt,
    submittedByName: record.recordedBy,
    formTypeLabel: MANUAL_PATIENT_LIST_LABELS[record.type],
    patientLabel: record.notes,
    isPaper: true,
    notes: record.notes,
  }));
}
